// Central icon registry. AppIcon (components/AppIcon.vue) renders these via
// Iconify. One semantic name -> one Iconify id. Swap the whole app's icon set
// by editing the ids here (e.g. change 'ph:house' to 'heroicons:home'); call
// sites never change. Names are kebab-case, derived from the original Phosphor
// component names (PhHouse -> 'house'). Seeded with ph: ids = current look.
export const ICONS = {
  'app-window': 'ph:app-window',
  'apple-logo': 'ph:apple-logo',
  'arrow-bend-down-right': 'ph:arrow-bend-down-right',
  'arrow-bend-left-up': 'ph:arrow-bend-left-up',
  'arrow-bend-up-left': 'ph:arrow-bend-up-left',
  'arrow-arc-left': 'ph:arrow-arc-left',
  'arrow-circle-up': 'ph:arrow-circle-up',
  'arrow-clockwise': 'ph:arrow-clockwise',
  'arrow-counter-clockwise': 'ph:arrow-counter-clockwise',
  'arrow-down-left': 'ph:arrow-down-left',
  'arrow-left': 'ph:arrow-left',
  'arrow-right': 'ph:arrow-right',
  'arrow-square-out': 'ph:arrow-square-out',
  'arrow-up': 'ph:arrow-up',
  'arrow-up-right': 'ph:arrow-up-right',
  'arrows-clockwise': 'ph:arrows-clockwise',
  'arrows-out-simple': 'ph:arrows-out-simple',
  'at': 'ph:at',
  'bell': 'ph:bell',
  'book-open-text': 'ph:book-open-text',
  'books': 'ph:books',
  'brain': 'ph:brain',
  'briefcase': 'ph:briefcase',
  'broadcast': 'ph:broadcast',
  'buildings': 'ph:buildings',
  'calendar-blank': 'ph:calendar-blank',
  'calendar-dots': 'ph:calendar-dots',
  'camera': 'ph:camera',
  'caret-double-left': 'ph:caret-double-left',
  'caret-double-right': 'ph:caret-double-right',
  'caret-down': 'ph:caret-down',
  'caret-left': 'ph:caret-left',
  'caret-right': 'ph:caret-right',
  'caret-up': 'ph:caret-up',
  'chat-circle': 'ph:chat-circle',
  'check': 'ph:check',
  'check-circle': 'ph:check-circle',
  'checks': 'ph:checks',
  'circle-notch': 'ph:circle-notch',
  'clock': 'ph:clock',
  'clock-counter-clockwise': 'ph:clock-counter-clockwise',
  'code': 'ph:code',
  'confetti': 'ph:confetti',
  'coins': 'ph:coins',
  'copy': 'ph:copy',
  'cpu': 'ph:cpu',
  'credit-card': 'ph:credit-card',
  'cube': 'ph:cube',
  'cursor-click': 'ph:cursor-click',
  'database': 'ph:database',
  'dot': 'ph:dot',
  'dots-three': 'ph:dots-three',
  'download-simple': 'ph:download-simple',
  'envelope-open': 'ph:envelope-open',
  'envelope-simple': 'ph:envelope-simple',
  'eye': 'ph:eye',
  'file': 'ph:file',
  'file-pdf': 'ph:file-pdf',
  'file-arrow-down': 'ph:file-arrow-down',
  'file-arrow-up': 'ph:file-arrow-up',
  'file-audio': 'ph:file-audio',
  'file-code': 'ph:file-code',
  'file-dashed': 'ph:file-dashed',
  'file-image': 'ph:file-image',
  'file-plus': 'ph:file-plus',
  'file-text': 'ph:file-text',
  'file-video': 'ph:file-video',
  'file-xls': 'ph:file-xls',
  'file-zip': 'ph:file-zip',
  'fire': 'ph:fire',
  'floppy-disk': 'ph:floppy-disk',
  'folder': 'ph:folder',
  'folder-open': 'ph:folder-open',
  'folder-plus': 'ph:folder-plus',
  'folders': 'ph:folders',
  'gauge': 'ph:gauge',
  'gear-six': 'ph:gear-six',
  'globe': 'ph:globe',
  'graduation-cap': 'ph:graduation-cap',
  'hash': 'ph:hash',
  'head-circuit': 'ph:head-circuit',
  'house': 'ph:house',
  'identification-card': 'ph:identification-card',
  'image': 'ph:image',
  'info': 'ph:info',
  'key': 'ph:key',
  'layout': 'ph:layout',
  'lifebuoy': 'ph:lifebuoy',
  'lightning': 'ph:lightning',
  'link': 'ph:link',
  'linux-logo': 'ph:linux-logo',
  'list': 'ph:list',
  'list-bullets': 'ph:list-bullets',
  'lock': 'ph:lock',
  'lock-key': 'ph:lock-key',
  'lock-open': 'ph:lock-open',
  'magic-wand': 'ph:magic-wand',
  'magnifying-glass': 'ph:magnifying-glass',
  'magnifying-glass-minus': 'ph:magnifying-glass-minus',
  'magnifying-glass-plus': 'ph:magnifying-glass-plus',
  'mailbox': 'ph:mailbox',
  'megaphone': 'ph:megaphone',
  'moon': 'ph:moon',
  'palette': 'ph:palette',
  'paper-plane-right': 'ph:paper-plane-right',
  'paper-plane-tilt': 'ph:paper-plane-tilt',
  'paperclip': 'ph:paperclip',
  'pause': 'ph:pause',
  'pencil-simple': 'ph:pencil-simple',
  'play': 'ph:play',
  'plugs': 'ph:plugs',
  'plugs-connected': 'ph:plugs-connected',
  'pulse': 'ph:pulse',
  'plus': 'ph:plus',
  'power': 'ph:power',
  'prohibit': 'ph:prohibit',
  'puzzle-piece': 'ph:puzzle-piece',
  'question': 'ph:question',
  'quotes': 'ph:quotes',
  'robot': 'ph:robot',
  'rocket-launch': 'ph:rocket-launch',
  'scan': 'ph:scan',
  'scroll': 'ph:scroll',
  'seal-check': 'ph:seal-check',
  'share-network': 'ph:share-network',
  'shield': 'ph:shield',
  'shield-check': 'ph:shield-check',
  'shield-slash': 'ph:shield-slash',
  'shield-warning': 'ph:shield-warning',
  'sign-in': 'ph:sign-in',
  'sign-out': 'ph:sign-out',
  'signpost': 'ph:signpost',
  'sparkle': 'ph:sparkle',
  'square': 'ph:square',
  'square-half': 'ph:square-half',
  'stack': 'ph:stack',
  'star': 'ph:star',
  'sun': 'ph:sun',
  'swatches': 'ph:swatches',
  'table': 'ph:table',
  'text-t': 'ph:text-t',
  'ticket': 'ph:ticket',
  'toggle-right': 'ph:toggle-right',
  'translate': 'ph:translate',
  'trash': 'ph:trash',
  'tray': 'ph:tray',
  'tree-structure': 'ph:tree-structure',
  'trend-up': 'ph:trend-up',
  'upload-simple': 'ph:upload-simple',
  'user': 'ph:user',
  'user-circle': 'ph:user-circle',
  'user-minus': 'ph:user-minus',
  'user-plus': 'ph:user-plus',
  'users': 'ph:users',
  'users-three': 'ph:users-three',
  'warning': 'ph:warning',
  'warning-circle': 'ph:warning-circle',
  'windows-logo': 'ph:windows-logo',
  'wrench': 'ph:wrench',
  'x': 'ph:x',
} as const;

export type IconName = keyof typeof ICONS;
